// WHAT A ROUTE IS CALLED.
//
// A route is what an operator switches on, attaches custom code to, tests, and then reads about in a log
// line — and in most of those places the canvas is not there to point at. So it has a name (V491), and when
// nobody has typed one the name is derived from where the route goes:
//
//     oxi-to-ohip          ohip-adapter-to-azure-blob-storage
//
// NOT ITS MODULES. The name used to carry them — ohip-adapter(/act,/ari,/blk,…,/rtp)-to-azure-blob-storage — which
// with seventeen modules is a paragraph, and is stale the first time a module is added. The chips beside the name
// say what it carries (V696 took the list out of the names already saved).
//
// SHARED, so the suggestion in the route dialog, the label on the canvas and the backfill in V491 all read
// the same. A route named on one screen and derived on another would look like two routes.

// 'Azure BLOB Storage' → 'azure-blob-storage'; 'Opera Cloud via OHIP' → 'opera-cloud-via-ohip'.
const slug = (text) => String(text || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

/** 'oxi-proxy' is the box; the name wants the protocol it speaks. */
export const sourceSlug = (adapter, fallback = 'source') =>
    slug(String(adapter || '').replace(/-proxy$/, '')) || fallback;

/**
 * The name a route would have if nobody typed one.
 *
 * @param {object}   route            the route as the designer holds it (either
 *                                    `backend_systems` — where it actually lands — or
 *                                    `target_system_name`, the KIND it is designed for)
 * @param {string}  [sourceAdapter]   the proxy the route leaves from, e.g. 'oxi-proxy'
 */
export const derivedRouteName = (route = {}, sourceAdapter) => {
    const carried = sourceSlug(sourceAdapter);
    // WHERE IT GOES, IF THAT IS DECIDED. Either it lands somewhere concrete (`backend_systems`, from
    // the binding an implementation filled in) or the template names the KIND it is for
    // (`target_system_name`, V510) — and both produce the SAME name, so a route reads identically on
    // the template and in every implementation of it.
    //
    // NO DESTINATION, NO "-to-". A route left deliberately open has no backend to name, and
    // "oxi-to-target" names a place that does not exist, in the one field a person reads to tell
    // two routes apart.
    const target = slug(route.backend_systems || route.target_system_name);
    return target ? `${carried}-to-${target}` : carried;
};

/** What to show: the name somebody gave it, else the derived one. Never blank. */
export const routeLabel = (route = {}, sourceAdapter) =>
    (route.name && String(route.name).trim()) || derivedRouteName(route, sourceAdapter);
